export default "__VITE_ASSET__BvZwWAXI__"